import { useReducer } from 'react';
import projectDataStore, {
  INITIAL_PROJECT_DATA,
} from '../store/projectData/projectDataStore';
import {
  ProjectDataStoreKind,
  ProjectDataStoreType,
} from 'src/store/projectData/projectDataStore.types';
import { getProjectData } from 'src/services/getProjectData';
import { getRandomProjectData } from 'src/services/getRandomProjectData';
import { Language } from 'src/store/language/languageStore.types';
import { ReportYears } from 'src/store/baseUrl/baseUrlStore.types';

export interface ProjectDataHook {
  state: ProjectDataStoreType;
  actions: {
    getProject: (
      id: string,
      language: Language,
      isMobileView: boolean,
      reportYears: ReportYears
    ) => void;
  };
}

const useProjectDataHook = (): ProjectDataHook => {
  const [state, dispatch] = useReducer(projectDataStore, INITIAL_PROJECT_DATA);

  const getProject: (
    id: string,
    language: Language,
    isMobileView: boolean,
    reportYears: ReportYears
  ) => Promise<void> = async (id, language, isMobileView, reportYears) => {
    try {
      const projectDetails = await getProjectData(id, language, isMobileView);
      dispatch({
        type: ProjectDataStoreKind.UPDATE_PROJECT_DETAILS,
        payload: projectDetails,
      });
      const err = reportYears
        ? projectDetails.year < reportYears.reportStartYear ||
          projectDetails.year > reportYears.reportEndYear
        : false;
      dispatch({
        type: ProjectDataStoreKind.UPDATE_PROJECT_DETAILS_ERROR,
        payload: err,
      });
    } catch (error) {
      dispatch({
        type: ProjectDataStoreKind.UPDATE_PROJECT_DETAILS_ERROR,
        payload: true,
      });
    }
    try {
      const randomProjects = await getRandomProjectData(
        language,
        isMobileView,
        reportYears
      );
      dispatch({
        type: ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS,
        payload: randomProjects,
      });
    } catch (error) {
      dispatch({
        type: ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS_DETAILS_ERROR,
      });
    }
  };

  return { state, actions: { getProject } };
};

export default useProjectDataHook;
